/**
 * Cloud template configurations (non-VCloud)
 * Matches: Cloud.VPS, Cloud.Hosting
 * Note: Cloud.VCloud is handled by vcloud template
 */
import type { TemplateConfig, TemplateField } from '../types'
import { createExpandedRowRender } from '../../expanded-row'
import { defaultQuotaCalculator, defaultIsExpandable } from '../shared'

// ============================================================================
// Fields
// ============================================================================

export const CLOUD_VPS_FIELDS: TemplateField[] = [
    { key: 'cpu', names: ['cpu', 'vcore', 'vcpu'], label: 'CPU' },
    { key: 'memory', names: ['memory', 'ram'], label: 'Memory' },
    { key: 'disk', names: ['disk', 'ssd', 'hdd', 'storage'], label: 'Disk' },
    { key: 'ip', names: ['ip', 'ip-address', 'ipv4', 'ipv6'], label: 'IP' },
    { key: 'bandwidth', names: ['bandwidth', 'bw'], label: 'Bandwidth' },
]

export const CLOUD_HOSTING_FIELDS: TemplateField[] = [
    { key: 'storage', names: ['storage'], label: 'Storage' },
    { key: 'website', names: ['website'], label: 'Website' },
    { key: 'mysql', names: ['mysql', 'my-sql'], label: 'MySQL' },
]

// ============================================================================
// Template Configs
// ============================================================================

export const cloudVPSTemplate: TemplateConfig = {
    id: 'cloud-vps',
    patterns: ['cloud.vps'],
    priority: 10,

    fields: CLOUD_VPS_FIELDS,

    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },

    calculateQuota: defaultQuotaCalculator,
}

export const cloudHostingTemplate: TemplateConfig = {
    id: 'cloud-hosting',
    patterns: ['cloud.hosting'],
    priority: 10,

    fields: CLOUD_HOSTING_FIELDS,

    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },

    calculateQuota: defaultQuotaCalculator,
}

// Export all cloud templates (non-VCloud)
export const cloudTemplates = [cloudVPSTemplate, cloudHostingTemplate]
